import React, { useRef, useState } from "react";
import { User, X } from "lucide-react";

async function fileToDataUrl(file, maxDim = 512, q = 0.85) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > maxDim || height > maxDim) {
          const s = Math.min(maxDim / width, maxDim / height);
          width = Math.round(width * s);
          height = Math.round(height * s);
        }
        const canvas = document.createElement("canvas");
        canvas.width = width; canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", q));
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

const FILE_INPUT_STYLE = {
  position: "absolute",
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
  opacity: 0,
};

export default function AvatarPicker({ value, onChange, testId = "avatar-picker" }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const onPick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const url = await fileToDataUrl(file);
      onChange(url);
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const openPicker = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    fileRef.current?.click();
  };

  return (
    <div className="flex items-center gap-3 relative" data-testid={testId}>
      {value ? (
        <img src={value} alt="" className="w-20 h-20 object-cover border-2 border-[#FF6B00]" />
      ) : (
        <div className="w-20 h-20 bg-[#0E0E0E] border-2 border-[#262626] inline-flex items-center justify-center">
          <User size={28} className="text-[#A3A3A3]" />
        </div>
      )}
      <div className="flex gap-2">
        <button type="button" disabled={busy} onClick={openPicker}
          className="stb-btn stb-btn-secondary" data-testid={`${testId}-pick`}>
          {value ? "Změnit fotku" : "Nahrát fotku"}
        </button>
        {value && (
          <button type="button" onClick={() => onChange(null)}
            className="stb-btn stb-btn-ghost" data-testid={`${testId}-remove`}>
            <X size={14} /> Smazat
          </button>
        )}
      </div>
      <input
        ref={fileRef}
        type="file"
        accept="image/*,.jpg,.jpeg,.png,.webp,.gif"
        onChange={onPick}
        style={FILE_INPUT_STYLE}
        tabIndex={-1}
        aria-hidden="true"
        data-testid={`${testId}-input`}
      />
    </div>
  );
}
